import ButtonLoading from "../../Button/ButtonLoading";
import React, { useState } from "react";
import { apiPost } from "../../../services/Api/apiCall";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { enqueueSnackbar } from "notistack";
import { queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useQueryClient } from "@tanstack/react-query";
import { Stack } from "@mui/material";
import { CasePdfGeneratorFormValues } from "../../../types/CasePdfGenerator";
import { UseFormReturn } from "react-hook-form";
import { useCurrentEditor } from "@tiptap/react";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";
import { ProductUnion } from "../../../types/ProductUnion";

type CaseSaveDraftProps = {
  product: ProductUnion;
  formContext: UseFormReturn<CasePdfGeneratorFormValues>;
};

const PdfGeneratorDraftSave = ({ product, formContext }: CaseSaveDraftProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();
  const { editor } = useCurrentEditor();

  const saveDraft = async () => {
    try {
      setIsLoading(true);

      // destruct intentionally to omit 'filename' from being saved in draft
      // to use the filename with autofill logic
      const { filename, ...filteredFormValues } = formContext.getValues();

      await apiPost("form_drafts", {
        title: "Entwurf_" + filename + ".pdf",
        formData: {
          ...filteredFormValues,
          content: getEditorHtml(editor),
        },
        backofficeCase: product.backofficeCase["@id"],
        creator: currentUser["@id"],
      });
      await queryClient.invalidateQueries(
        {
          queryKey: queryKeys.collection("form_drafts", { backofficeCase: product.backofficeCase.id })
        }
      );
    } catch (error) {
      enqueueSnackbar("Es ist ein Fehler aufgetreten", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack direction={"row"} sx={{
      justifyContent: "center"
    }}>
      <ButtonLoading variant={"text"} fullWidth={false} onClick={saveDraft} isLoading={isLoading}>
        Entwurf Speichern
      </ButtonLoading>
    </Stack>
  );
};
export default PdfGeneratorDraftSave;
